<template>
  <!--分支机构-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '名称',
          dataIndex: 'branchName',
          key: 'branchName',
        },
        {
          title: '负责人',
          dataIndex: 'branchPrincipal',
          key: 'branchPrincipal',
        },
        {
          title: '注册号',
          dataIndex: 'unifiedSocialCreditCode',
          key: 'unifiedSocialCreditCode',
        },
        {
          title: '登记机关',
          dataIndex: 'registrationInstitution',
          key: 'registrationInstitution',
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {},
}
</script>
